import { StylesConfig } from 'react-select';

export const customSelectStyles: StylesConfig<
  {
    label: string;
    value: string | number;
  },
  false
> = {
  placeholder: (provided) => ({
    ...provided,
    paddingLeft: 0,
    color: 'var(--text-tertiary)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '0',
    fontSize: '16px',
    lineHeight: '1.7',
  }),
  control: (provided) => ({
    ...provided,
    background: 'transparent',
    borderBottom: 'none',
    borderRadius: 'inherit',
    borderRight: 'none',
    borderLeft: 'none',
    borderTop: 'none',
    borderColor: 'none',
    boxShadow: 'none',
    overflow: 'hidden',
    textOverflow: 'unset',
    whiteSpace: 'nowrap',
    '&:hover': {},
  }),
  option: (provided, state) => ({
    ...provided,
    color: 'var(--text-primary)',
    backgroundColor: state.isFocused
      ? 'var(--bg-tertiary-50)'
      : 'var(--bg-primary)',
    textAlign: 'left',
    fontSize: '16px',
    cursor: 'pointer',
    '&:active': {
      background: 'var(--bg-active)',
      color: 'var(--text-active)',
    },
    overflowWrap: 'break-word',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 3,
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: 'var(--bg-primary)',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    overflow: 'inherit',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: 'inherit',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'inherit',
    fontSize: '16px',
  }),
};
